module.exports = __webpack_public_path__ + "img/enterprise-institution-5.bc684115.png";